import { SUPPORTED_CHAIN_IDS } from '@/config/chain/constants'
import { usePathname } from 'next/navigation'

import { useAccount } from 'wagmi'

export function useWrongNetwork(): boolean {
  const { address, chainId } = useAccount()
  const pathname = usePathname()

  const isWrongNetwork = address && chainId && !(SUPPORTED_CHAIN_IDS as number[]).includes(chainId)

  // Exclude bridge page from wrong network check (supports cross-chain)
  if (pathname === '/bridge') {
    return false
  }

  return Boolean(isWrongNetwork)
}
